import { createFileRoute } from "@tanstack/react-router";
import CampanasWhatsapp from "../../pages/soluciones/CampanasWhatsapp";

export const Route = createFileRoute("/que-hacemos/campanas-whatsapp")({
  component: CampanasWhatsapp,
});
